import { render } from "./CloseDepositButton.vue?vue&type=template&id=6bb8720d"
import script from "./CloseDepositButton.vue?vue&type=script&lang=js"
export * from "./CloseDepositButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__